<script lang="javascript">
	import {onMount} from 'svelte';
	import {fade} from 'svelte/transition';

    export let title = 'Test Title';
    export let excerpt = 'Lorem ipsum etc etc etc ';
    export let thumbnailPath = 'https://bigthink.com/wp-content/uploads/2024/03/college2.jpg?resize=1280,720';
    export let url = 'https://bigthink.com/the-present/value-of-a-college-degree-has-fallen/';
    export let onClose = () => {};

    let imagePathPrepared = thumbnailPath;

    $: {
        const pathWithoutQuery = thumbnailPath.split('?')[0];
        imagePathPrepared = pathWithoutQuery + '?w=1024&h=1024&crop=1';
    }

    let ready = false;

    onMount(() => {
        ready = true;
    });

    const handleClose = () => {
        setTimeout(() => {
            onClose();
        }, 10);
    }

</script>

{#if ready}
<div class="fixed z-[400] top-0 left-0 w-[100vw] h-[100dvh] max-h-full" transition:fade={{ duration: 200 }} >
    <!-- modal overlay and event catch -->
    <div class="z-10 absolute top-0 left-0 w-full h-full pointer-events-none bg-[rgba(255,255,255,0.95)]"></div>

    <!-- modal content -->
    <div class="relative z-20 p-6 text-black w-[100vw] h-[100vh] overflow-y-auto">
        <!-- close button -->
        <button class="absolute top-4 right-4 w-9 h-9 rounded-full" on:click|preventDefault={handleClose}>
            <svg class="w-9 h-9" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 8.586l3.293-3.293 1.414 1.414L11.414 10l3.293 3.293-1.414 1.414L10 11.414l-3.293 3.293-1.414-1.414L8.586 10 5.293 6.707l1.414-1.414L10 8.586z" clip-rule="evenodd"/>
            </svg>
        </button>

        <div class="pt-14 pb-10 w-full">
            <div class="sm:hidden">
                <div class="font-headline font-bold text-3xl/tight">
                    {title}
                </div>
                <div class="mt-3 aspect-square">
                    <img class="w-full h-auto" src={imagePathPrepared} alt={title} />
                </div>
                <div class="mt-3 font-utlity text-base">
                    {@html excerpt}
                </div> 
                <div class="mt-3 ">
                    <a href={url} class="block text-white text-sm font-bold uppercase font-utlity bg-black p-4 w-full max-w-96 text-center mx-auto">
                        Go to the article
                    </a>
                </div>
            </div>
            <div class="hidden sm:block">
                <div class="flex gap-8 items-center">
                    <div class="w-1/2">
                        <div class="font-headline font-bold text-3xl/tight">
                            {title}
                        </div>
                        <div class="mt-3 font-utlity text-base">
                            {@html excerpt}
                        </div> 
                        <div class="mt-5">
                            <a href={url} class="block text-white text-sm font-bold uppercase font-utlity bg-black p-4 w-full max-w-96 text-center">
                                Go to the article
                            </a>
                        </div>
                    </div>
                    <div class="w-1/2">
                        <div class="aspect-square">
                            <img class="w-full h-auto" src={imagePathPrepared} alt={title} />
                        </div>
                    </div>
                </div>
            </div>
        </div>  
    </div>      
</div>  
{/if}

<style>

</style>